import { put, takeLatest } from "redux-saga/effects";
import {
  GET_CLOUD_DOCUMENTS,
  GET_CLOUD_DOCUMENTS_FAILED,
  GET_CLOUD_DOCUMENTS_INIT,
  GET_CLOUD_DOCUMENTS_SUCCESS,
  UPLOAD_FILE_DECK,
  UPLOAD_FILE_DECK_INIT,
  UPLOAD_FILE_DECK_SUCCESS,
  UPLOAD_FILE_DECK_FAILED,
} from "./constants";
import { getUtil, postUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import GenerateUrl from "@hedgefund/shared/src/GenerateUrl";

const getDocumentParams = [
  { keyword: "RecordId", value: "recordId" },
  { keyword: "RecordType", value: "recordType" },
  { keyword: "DocType", value: "docType" },
];

export function* getFundDocuments({ payload }) {
  try {
    yield put({ type: GET_CLOUD_DOCUMENTS_INIT });

    let url = API.getRecordFiles + GenerateUrl(payload, getDocumentParams);

    const res = yield getUtil(url);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: GET_CLOUD_DOCUMENTS_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: GET_CLOUD_DOCUMENTS_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* uploadFileDeckSaga({ payload, onSuccessAlert, onCloseModal }) {
  yield put({ type: UPLOAD_FILE_DECK_INIT });
  try {

    const res = yield postUtil(`${API.UploadFileDeck}`, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: UPLOAD_FILE_DECK_SUCCESS,
        payload: data.result,
      });
      onCloseModal();
      onSuccessAlert();
    } else {
      yield put({ type: UPLOAD_FILE_DECK_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}
export function* CloudDocumentSaga() {
  yield takeLatest(GET_CLOUD_DOCUMENTS, getFundDocuments);
  yield takeLatest(UPLOAD_FILE_DECK, uploadFileDeckSaga);
}
